export default __webpack_public_path__ + "static/media/asuite-logo.84df0f58.png";